define('views/parts/modal/create-test-client-modal',[
    'mustache',
    'services/i18n',
    'services/events/user-events',
    'views/parts/modal/modal',
    'text!templates/parts/modal/create-test-client-modal.html',
], function(
    Mustache, i18n, UserEvents, VModal, TCreateTestClientModal
) {

    var VCreateTestClientModal = VModal.extend({
        template: TCreateTestClientModal,

        events: {
            'click .add-test-client': "onAddTestClient"
        },

        modal: function() {
            return {
                title: i18n.t('Create a test client'),
                size: 'medium'
            };
        },

        initialize: function(profile) {
            this.profile = profile
        },

        buttons: function() {
            return {
                confirm: {
                    label: i18n.t("Ok"),
                    callback: this.onConfirm,
                },
            }
        },

        render: function() {
            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext({})));
            this.renderModal();

            return this;
        },

        onAddTestClient: function(e) {
            e.preventDefault();

            this.profile.save({ isHiddenFromClientsList: false }, {
                patch: true,
                success: this.onSuccess.bind(this)
            });
        },

        onSuccess: function() {
            UserEvents.testUserAdded(this.profile, false);
            this.close();
        }
    });

    return VCreateTestClientModal;
});

